import { render, staticRenderFns } from "./OsEntityForm.vue?vue&type=template&id=6464f7be&scoped=true"
import script from "./OsEntityForm.vue?vue&type=script&lang=ts"
export * from "./OsEntityForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6464f7be",
  null
  
)

export default component.exports